var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{on:{"click":_vm.test_01}},[_vm._v("GET PRODUCTS")]),_vm._v(" "+_vm._s(_vm.products)+" "),_c('button',{on:{"click":_vm.syncSearch}},[_vm._v("Sync with search")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }